import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import RemovableVenue from "components/Removables/RemovableVenue";
import { useOpenNewCompanySidePanel } from "components/SidePanel/Company/NewCompanySidePanel";
import React from "react";
import { ModalPickerProps } from "../props";
import VenueList from "./VenueList";
import { AfterCreateAction } from "components/SidePanel/types";

type Props = Omit<ModalPickerProps<server.dto.VenueSmall>, "canCreateNew"> & (
  | { canCreateNew: false; afterCreate?: AfterCreateAction }
  | { canCreateNew: boolean; afterCreate: AfterCreateAction }
);

const VenueModalPicker = (props: Props) => {
  const openNewCompanySidePanel = useOpenNewCompanySidePanel();
  const onChange = (value: server.dto.VenueSmall) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };

  return <>
    <ModalPickerWithChooseButton
      canCreateNew={props.canCreateNew}
      onNewClicked={() => openNewCompanySidePanel({
        type: "venue",
        disableVenue: true,
        onCreated: (c) => onChange({
          venueId: c.companyId,
          name: c.name,
          cityCountry: [c.address.city, c.address.countryName].filter(Boolean).join(", "),
          location: c.geoCode.location,
          isValidated: c.isValidated,
          ageRestriction: "unknown",
          capacity: undefined,
          category: "unknown"
        }),
        afterCreate: props.afterCreate ?? "closeSidebar"
      })}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={site.currentEnvironment.functionGroups.venue.plural}
      modalSize="tiny"
      renderModalContent={(closeModal) => <VenueList
        onItemSelected={(venue) => {
          closeModal();
          onChange(venue);
        }}
      />}
      renderRemovable={(props) => <RemovableVenue {...props} />}
      {...props}
    />
  </>
};

export default VenueModalPicker;